// extracted by mini-css-extract-plugin
module.exports = {"container":"BlocFilter_container__YBDuF","color-filter":"BlocFilter_color-filter__Qhx9_","content":"BlocFilter_content__RxjV8"};